import React from 'react';
import {tabNames} from "../constants";
import {Link} from "react-router-dom";
import {isAdmin} from "../commons";

function Header(props) {

    const handleOnLogoutClick = (e) => {
        e.preventDefault();
        props.handleLogout()
    };

    const navigationTabs = () => {
        if (props.isAuthenticated()) {
            return (
                <ul className="nav nav-pills pull-right">
                    <li className={props.activeTab === tabNames.SESSIONS ? 'active' : ''}>
                        <Link to="/sessions">Sessions</Link>
                    </li>
                    <li className={props.activeTab === tabNames.CALENDAR ? 'active' : ''}>
                        <Link to="/calendar">Calendar</Link>
                    </li>
                    <li>
                        <a href={process.env.REACT_APP_API_URL + "/overview"} target="_blank">Overview</a>
                    </li>
                    <li>
                        <a href={process.env.REACT_APP_API_URL + "/preview"} target="_blank">Preview</a>
                    </li>
                    {isAdmin(props.user) ?
                        <li className={props.activeTab === tabNames.ADMIN ? 'active' : ''}>
                            <Link to="/admin">Admin Panel</Link>
                        </li> :
                        <li className={props.activeTab === tabNames.SETTINGS ? 'active' : ''}>
                            <Link to="/settings">Settings</Link>
                        </li>
                    }
                    <li>
                        <span className="glyphicon glyphicon-log-out pointer"
                              aria-hidden="true"
                              onClick={handleOnLogoutClick}
                              style={{padding: "10px 15px"}}
                              title="Log out">
                            </span>
                    </li>
                </ul>
            )
        } else {
            return (
                <ul className="nav nav-pills pull-right">
                    <li>
                        <Link to="/login">Log in</Link>
                    </li>
                </ul>
            )
        }
    };


    return (
        <div id="header">
            <h1>{props.title}</h1>
            <nav>
                {navigationTabs()}
            </nav>
        </div>
    )
}

export default Header;

